<script setup lang="ts">
export interface IconPlayingTag {
  fill?: string;
  percentage?: number;
  isDarkTheme?: boolean;
}
const props = withDefaults(defineProps<IconPlayingTag>(), { fill: "#fff", percentage: 0, isDarkTheme: true });
const circle = computed(() => `${(props.percentage / 104) * 100 * Math.PI},9999`);
</script>

<circle cx="50" cy="50" r="49" fill="none" stroke="rgb(217, 217, 217)" stroke-width="0.5" />

<template>
  <svg width="36" height="36" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="50"
      cy="50"
      r="49"
      :fill="props.isDarkTheme ? '#2C374B' : 'none'"
      :stroke="!props.isDarkTheme ? 'rgb(217, 217, 217)' : 'none'" stroke-width="3"
    />
    <circle class="icon-pause" transform="rotate(-91 50 50)" cx="50" cy="50" r="48" stroke="red" stroke-width="3" :stroke-dasharray="circle" />
    <rect x="35" y="31" width="10" height="39" :fill="props.isDarkTheme ? '#FFF' : '#8F959F'" />
    <rect x="56" y="31" width="10" height="39" :fill="props.isDarkTheme ? '#FFF' : '#8F959F'" />
  </svg>
</template>

<style lang="scss">
  .icon-pause {
    transition: all 1s ease;
  }
</style>
